// AccessoriesHero.jsx
import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useNavigate } from "react-router-dom";
import "../../../../assests/css/customer/AccHero.css";
import jae2 from '../../../../assests/images/jae2.jpg';
import jae1 from '../../../../assests/images/jae1.jpg';


const AccHero = () => {
  const leftCardRef = useRef(null);
  const rightCardRef = useRef(null);
  const leftButtonRef = useRef(null);
  const rightButtonRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    tl.fromTo(
      leftCardRef.current,
      { x: -100, opacity: 0, scale: 0.9 },
      { x: 0, opacity: 1, scale: 1, duration: 1, ease: "back.out(1.2)" }
    )
      .fromTo(
        rightCardRef.current,
        { x: 100, opacity: 0, scale: 0.9 },
        { x: 0, opacity: 1, scale: 1, duration: 1, ease: "back.out(1.2)" },
        "-=0.7"
      )
      .fromTo(
        [leftButtonRef.current, rightButtonRef.current],
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, stagger: 0.2 },
        "-=0.5"
      );
  }, []);

  const handleDiscover = (path) => {
    navigate(path);
  };

  return (
    <section className="acc-accessories-hero">
      <div className="acc-hero-container">

        {/* Gifts for Her */}
        <div className="acc-hero-card" ref={leftCardRef}>
          <div className="acc-card-image-wrapper">
            <img
             src={jae2}
              alt="Gifts for Her"
              className="acc-card-image"
            />
            <div className="acc-card-overlay" />
          </div>

          <div className="acc-card-content">
            <h2 className="acc-card-title">Gifts for Her</h2>
            <p className="acc-card-description">
              Elegant gestures that celebrate her timeless allure.
            </p>

            <button
              ref={leftButtonRef}
              className="acc-discover-btn"
              onClick={() => handleDiscover('/accessories/women')}
            >
              <span className="acc-btn-text">DISCOVER</span>
              <span className="acc-btn-line" />
            </button>
          </div>
        </div>

        {/* Gifts for Him */}
        <div className="acc-hero-card" ref={rightCardRef}>
          <div className="acc-card-image-wrapper">
            <img
              src={jae1}
              alt="Gifts for Him"
              className="acc-card-image"
            />
            <div className="acc-card-overlay" />
          </div>

          <div className="acc-card-content">
            <h2 className="acc-card-title">Gifts for Him</h2>
            <p className="acc-card-description">
              Essentials of style, designed for the art of gifting.
            </p>

            <button
              ref={rightButtonRef}
              className="acc-discover-btn"
              onClick={() => handleDiscover('/accessories/men')}
            >
              <span className="acc-btn-text">DISCOVER</span>
              <span className="acc-btn-line" />
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AccHero;